export enum ApiVersion {
  V1,
  V2,
  V3
}
